(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[323],{

/***/ 3255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Component = function(_param) {
    var as = _param.as, children = _param.children, props = _objectWithoutProperties(_param, [
        "as",
        "children"
    ]);
    return(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as, props, children));
};
Component.propTypes = {
    as: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node.isRequired),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
Component.defaultProps = {
    as: 'div'
};
/* harmony default export */ __webpack_exports__["Z"] = (Component);


/***/ }),

/***/ 8049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3255);
/* harmony import */ var _container_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5185);
/* harmony import */ var _container_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_container_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Container = function(_param) {
    var className = _param.className, children = _param.children, props = _objectWithoutProperties(_param, [
        "className",
        "children"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_container_module_scss__WEBPACK_IMPORTED_MODULE_3__.container, className)
    }, props, {
        children: children
    })));
};
Container.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 8492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ DATA_TYPES; },
  "Z": function() { return /* binding */ layout; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
// EXTERNAL MODULE: ../../node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(5455);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/components/container.js
var container = __webpack_require__(8049);
// EXTERNAL MODULE: ../../node_modules/luxon/build/cjs-browser/luxon.js
var luxon = __webpack_require__(6299);
// EXTERNAL MODULE: ./src/components/typography/anchor.js
var typography_anchor = __webpack_require__(8472);
// EXTERNAL MODULE: ./src/components/typography/text.js
var typography_text = __webpack_require__(829);
// EXTERNAL MODULE: ./src/images/icons/facebook.svg
var facebook = __webpack_require__(7095);
;// CONCATENATED MODULE: ./src/images/icons/instagram.svg
/* harmony default export */ var instagram = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ./src/images/icons/twitter.svg
var twitter = __webpack_require__(1544);
;// CONCATENATED MODULE: ./src/images/icons/youtube.svg
/* harmony default export */ var youtube = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMjQgMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNvbm1vbnN0ci15b3V0dWJlLTY8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Imljb25tb25zdHIteW91dHViZS02IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4wMDAwMDAsIC0wLjAwMDEyNSkiIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xOS42MTUsMC4xODQxMjUxOTEgQzE2LjAxMSwtMC4wNjE4NzQ4MDkxIDcuOTg0LC0wLjA2MDg3NDgwOTEgNC4zODUsMC4xODQxMjUxOTEgQzAuNDg4LDAuNDUwMTI1MTkxIDAuMDI5LDIuODA0MTI1MTkgMCw5LjAwMDEyNTE5IEMwLjAyOSwxNS4xODUxMjUyIDAuNDg0LDE3LjU0OTEyNTIgNC4zODUsMTcuODE2MTI1MiBDNy45ODUsMTguMDYxMTI1MiAxNi4wMTEsMTguMDYyMTI1MiAxOS42MTUsMTcuODE2MTI1MiBDMjMuNTEyLDE3LjU1MDEyNTIgMjMuOTcxLDE1LjE5NjEyNTIgMjQsOS4wMDAxMjUxOSBDMjMuOTcxLDIuODE1MTI1MTkgMjMuNTE2LDAuNDUxMTI1MTkxIDE5LjYxNSwwLjE4NDEyNTE5MSBaIE05LDEzLjAwMDEyNTIgTDksNS4wMDAxMjUxOSBMMTcsOC45OTMxMjUxOSBMOSwxMy4wMDAxMjUyIEw5LDEzLjAwMDEyNTIgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=");
;// CONCATENATED MODULE: ./src/images/icons/telegram.svg
/* harmony default export */ var telegram = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./src/images/icons/pod.svg
/* harmony default export */ var pod = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjExcHgiIGhlaWdodD0iMjMycHgiIHZpZXdCb3g9IjAgMCAyMTEgMjMyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPlNoYXBlPC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik05Ny44NCwyMzAuNjQgQzg4Ljg5LDIyNy40NCA4Ni45NywyMjMuMDkgODMuMywxOTcuNiBDNzkuMDMsMTY3Ljk3IDc4LjEsMTQ5LjYzIDgwLjU3LDE0My44MiBDODMuODUsMTM2LjEyIDkyLjc1LDEzMS43NSAxMDUuMiwxMzEuNjk5NTc5IEMxMTcuNTUsMTMxLjY1IDEyNi41MywxMzYuMDYgMTI5LjgzLDE0My44MiBDMTMyLjMxLDE0OS42MiAxMzEuMzgsMTY3Ljk3IDEyNy4xMSwxOTcuNiBDMTI0LjIxLDIxOC4zIDEyMi42MSwyMjMuNTMgMTE4LjYxLDIyNy4wNSBDMTEzLjExLDIzMS45MiAxMDUuMzEsMjMzLjI3IDk3LjkxLDIzMC42NSBMOTcuODQsMjMwLjY0IFogTTU5LjYxLDIwMC4yNCBDMjguNzEsMTg1LjA0IDguOTEsMTU5LjMyIDEuNzEsMTI1LjEgQy0wLjA5LDExNi4yNyAtMC4zOSw5NS4yIDEuMzEsODcuMSBDNS44MSw2NS4zNSAxNC40MSw0OC4zNCAyOC43MSwzMy4zIEM0OS4zMSwxMS41OCA3NS44MSwwLjEgMTA1LjMxLDAuMSBDMTM0LjUxLDAuMSAxNjAuOTEsMTEuMzcgMTgxLjAxLDMyLjQ0IEMxOTYuMzEsNDguMzQgMjA0LjkxLDY1LjE3IDIwOS4zMSw4Ny4zNCBDMjEwLjgxLDk0LjcyIDIxMC44MSwxMTQuODQgMjA5LjQxLDEyMy4xNCBDMjA0LjgxLDE0OS4zOCAxOTAuMjEsMTczLjI4IDE2OC45MSwxODkuMzQgQzE2MS4zMSwxOTUuMDggMTQyLjcxLDIwNS4xIDEzOS43MSwyMDUuMSBDMTM4LjYxLDIwNS4xIDEzOC41MSwyMDMuOTYgMTM5LjAxLDE5OS4zNSBDMTM5LjkxLDE5MS45NSAxNDAuODEsMTkwLjQxIDE0NS4wMSwxODguNjUgQzE1MS43MSwxODUuODUgMTYzLjExLDE3Ny43MyAxNzAuMTEsMTcwLjcxIEMxODIuMjEsMTU4LjcxIDE5MS4xMSwxNDMuMDEgMTk1LjIxLDEyNi41MSBDMTk3LjgxLDExNi4yMSAxOTcuNTEsOTMuMzEgMTk0LjYxLDgyLjcxIEMxODUuNTEsNDkuMDEgMTU4LjAxLDIyLjgxIDEyNC4zMSwxNS44MSBDMTE0LjUxLDEzLjgxIDk2LjcxLDEzLjgxIDg2LjgxLDE1LjgxIEM1Mi43MSwyMi44MSAyNC41MSw1MC4zMSAxNS45MSw4NC45MSBDMTMuNjEsOTQuMzEgMTMuNjEsMTE3LjIxIDE1LjkxLDEyNi42MSBDMjEuNjEsMTQ5LjUxIDM2LjQxLDE3MC41MSA1NS44MSwxODMuMDEgQzU5LjYxLDE4NS41MSA2NC4yMSwxODguMTEgNjYuMTEsMTg4LjkxIEM3MC4zMSwxOTAuNzEgNzEuMjEsMTkyLjIxIDcyLjAxLDE5OS42MSBDNzIuNTEsMjA0LjExIDcyLjQxLDIwNS40MSA3MS4zMSwyMDUuNDEgQzcwLjYxLDIwNS40MSA2NS41MSwyMDMuMjEgNjAuMTEsMjAwLjYxIEw1OS42MSwyMDAuMjQgWiBNNjAuMDEsMTU5LjU2IEM0OS42MSwxNTEuMjYgNDAuNDEsMTM2LjU0IDM2LjYxLDEyMi4xIEMzNC4zMSwxMTMuMzggMzQuMzEsOTYuOCAzNi43MSw4OC4xIEM0My4wMSw2NC42MiA2MC4zMSw0Ni40MiA4NC4zMSwzNy44NyBDOTIuNTEsMzQuOTcgMTEwLjcxLDM0LjMyIDEyMC44MSwzNi41NSBDMTU1LjYxLDQ0LjMgMTgwLjMxLDc5LjE1IDE3NS41MSwxMTMuNzIgQzE3My42MSwxMjcuNjUgMTY4LjgxLDEzOS4wOSAxNjAuMzEsMTQ5LjcyIEMxNTYuMTEsMTU1LjA5IDE0NS45MSwxNjQuMSAxNDQuMTEsMTY0LjEgQzE0My44MSwxNjQuMSAxNDMuNTEsMTYwLjcgMTQzLjUxLDE1Ni41NiBMMTQzLjUxLDE0OSBMMTQ4LjcxLDE0Mi44IEMxNjguMzEsMTE5LjMyIDE2Ni45MSw4Ni41MiAxNDUuNTEsNjUgQzEzNy4yMSw1Ni42MiAxMjcuNjEsNTEuNyAxMTUuMjEsNDkuNDMgQzEwNy4yMSw0Ny45NSAxMDUuNTEsNDcuOTUgOTcuMTEsNDkuMzMgQzg0LjM2LDUxLjQxIDc0LjQ4LDU2LjM1IDY1LjcxLDY1LjAzIEM0NC4yMSw4Ni4zMyA0Mi44MSwxMTkuMyA2Mi40MSwxNDIuOCBMNjcuNTcsMTQ5IEw2Ny41NywxNTYuNiBDNjcuNTcsMTYwLjggNjcuMjQsMTY0LjIgNjYuODMsMTY0LjIgQzY2LjQzLDE2NC4yIDYzLjUzLDE2Mi4yIDYwLjQzLDE1OS43IEw2MC4wMSwxNTkuNTYgWiBNOTQuNzEsMTE4LjczIEM4NS44MSwxMTQuNTkgODEuMDEsMTA2Ljc4IDgwLjkxLDk2LjYgQzgwLjkxLDg3LjQ1IDg2LjAxLDc5LjQ3IDk0LjgxLDc0LjggQzEwMC40MSw3MS44NiAxMTAuMzEsNzEuODYgMTE1LjkxLDc0LjgyIEMxMjIuMDEsNzcuOTkgMTI3LjAxLDg0LjE0IDEyOC45MSw5MC41NiBDMTM0LjcxLDExMC4yOCAxMTMuODEsMTI3LjU2IDk0LjkxLDExOC43MyBMOTQuNzEsMTE4LjczIFoiIGlkPSJTaGFwZSIgZmlsbD0iIzAwMDAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICA8L2c+Cjwvc3ZnPg==");
;// CONCATENATED MODULE: ./src/images/icons/twitch.svg
/* harmony default export */ var twitch = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNvbm1vbnN0ci10d2l0Y2gtMTwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iaWNvbm1vbnN0ci10d2l0Y2gtMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41MzcwMDAsIC0wLjAwMDAwMCkiIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjYxMiwwIEw4Ljg4MTc4NDJlLTE2LDQuMTE5IEw4Ljg4MTc4NDJlLTE2LDIwLjk1NSBMNS43MzEsMjAuOTU1IEw1LjczMSwyNCBMOC45NTUsMjQgTDEyLDIwLjk1NSBMMTYuNjU3LDIwLjk1NSBMMjIuOTI2LDE0LjY4NiBMMjIuOTI2LDAgTDEuNjEyLDAgWiBNMjAuNzc2LDEzLjYxMiBMMTcuMTk0LDE3LjE5NCBMMTEuNDYzLDE3LjE5NCBMOC40MTgsMjAuMjM5IEw4LjQxOCwxNy4xOTQgTDMuNTgyLDE3LjE5NCBMMy41ODIsMi4xNDkgTDIwLjc3NiwyLjE0OSBMMjAuNzc2LDEzLjYxMiBMMjAuNzc2LDEzLjYxMiBaIE0xNy4xOTQsNi4yNjkgTDE3LjE5NCwxMi41MzEgTDE1LjA0NSwxMi41MzEgTDE1LjA0NSw2LjI2OSBMMTcuMTk0LDYuMjY5IFogTTExLjQ2Myw2LjI2OSBMMTEuNDYzLDEyLjUzMSBMOS4zMTQsMTIuNTMxIEw5LjMxNCw2LjI2OSBMMTEuNDYzLDYuMjY5IEwxMS40NjMsNi4yNjkgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=");
;// CONCATENATED MODULE: ./src/images/icons/reddit.svg
/* harmony default export */ var reddit = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aWNvbm1vbnN0ci1yZWRkaXQtMTwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iaWNvbm1vbnN0ci1yZWRkaXQtMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMDAwMDAwLCAwLjAwMDAwMCkiIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNCw5Ljc3OSBDMjQsOC4zMiAyMi44MDgsNy4xMzQgMjEuMzQzLDcuMTM0IEMyMC42MjgsNy4xMzQgMTkuOTgsNy40MiAxOS41MDMsNy44OCBDMTcuNjkzLDYuNjg5IDE1LjI0NCw1LjkzMSAxMi41MzIsNS44MzQgTDE0LjAxNSwxLjE2NSBMMTguMDMxLDIuMTA2IEwxOC4wMjUsMi4xNjQgQzE4LjAyNSwzLjM1NyAxOSw0LjMyNyAyMC4xOTksNC4zMjcgQzIxLjM5Nyw0LjMyNyAyMi4zNzEsMy4zNTcgMjIuMzcxLDIuMTY0IEMyMi4zNzEsMC45NzEgMjEuMzk2LDAgMjAuMTk5LDAgQzE5LjI3OSwwIDE4LjQ5NSwwLjU3NCAxOC4xNzgsMS4zNzkgTDEzLjg0OSwwLjM2NCBDMTMuNjYsMC4zMTggMTMuNDY4LDAuNDI3IDEzLjQwOSwwLjYxMyBMMTEuNzU1LDUuODIgQzguOTE3LDUuODU0IDYuMzQ2LDYuNjE4IDQuNDU1LDcuODQ1IEMzLjk4MSw3LjQwNyAzLjM1Miw3LjEzMyAyLjY1Niw3LjEzMyBDMS4xOTEsNy4xMzMgMCw4LjMyIDAsOS43NzkgQzAsMTAuNzQ5IDAuNTMzLDExLjU5IDEuMzE3LDEyLjA1IEMxLjI2NSwxMi4zMzIgMS4yMzEsMTIuNjE3IDEuMjMxLDEyLjkwNyBDMS4yMzEsMTYuODE4IDYuMDM5LDIwIDExLjk1LDIwIEMxNy44NjEsMjAgMjIuNjcsMTYuODE4IDIyLjY3LDEyLjkwNyBDMjIuNjcsMTIuNjMzIDIyLjY0MSwxMi4zNjMgMjIuNTk1LDEyLjA5NyBDMjMuNDI3LDExLjY1IDI0LDEwLjc4NSAyNCw5Ljc3OSBaIE02Ljc3NiwxMS41OTUgQzYuNzc2LDEwLjcyNyA3LjQ4NiwxMC4wMiA4LjM1OCwxMC4wMiBDOS4yMywxMC4wMiA5LjkzOSwxMC43MjcgOS45MzksMTEuNTk1IEM5LjkzOSwxMi40NjMgOS4yMywxMy4xNjkgOC4zNTgsMTMuMTY5IEM3LjQ4NiwxMy4xNjkgNi43NzYsMTIuNDYzIDYuNzc2LDExLjU5NSBMNi43NzYsMTEuNTk1IFogTTE1LjgzNywxNi4yNjQgQzE1LjA0LDE3LjA1NyAxMy43ODksMTcuNDQzIDEyLjAxMywxNy40NDMgTDEyLDE3LjQ0IEwxMS45ODcsMTcuNDQzIEMxMC4yMSwxNy40NDMgOC45NTksMTcuMDU3IDguMTYzLDE2LjI2NCBDOC4wMTgsMTYuMTIgOC4wMTgsMTUuODg1IDguMTYzLDE1Ljc0MSBDOC4zMDgsMTUuNTk2IDguNTQ0LDE1LjU5NiA4LjY4OSwxNS43NDEgQzkuMzM5LDE2LjM4OCAxMC40MTgsMTYuNzAyIDExLjk4NywxNi43MDIgTDEyLDE2LjcwNSBMMTIuMDEzLDE2LjcwMiBDMTMuNTgyLDE2LjcwMiAxNC42NjEsMTYuMzg3IDE1LjMxMSwxNS43NCBDMTUuNDU2LDE1LjU5NSAxNS42OTIsMTUuNTk2IDE1LjgzNywxNS43NCBDMTUuOTgyLDE1Ljg4NSAxNS45ODIsMTYuMTE5IDE1LjgzNywxNi4yNjQgWiBNMTUuNjQ4LDEzLjE2OSBDMTQuNzc2LDEzLjE2OSAxNC4wNjcsMTIuNDYzIDE0LjA2NywxMS41OTUgQzE0LjA2NywxMC43MjcgMTQuNzc2LDEwLjAyIDE1LjY0OCwxMC4wMiBDMTYuNTIsMTAuMDIgMTcuMjI5LDEwLjcyNyAxNy4yMjksMTEuNTk1IEMxNy4yMjksMTIuNDYzIDE2LjUyLDEzLjE2OSAxNS42NDgsMTMuMTY5IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");
// EXTERNAL MODULE: ./src/siteconfig.js
var siteconfig = __webpack_require__(7082);
// EXTERNAL MODULE: ./src/components/footer.module.scss
var footer_module = __webpack_require__(8831);
;// CONCATENATED MODULE: ./src/components/footer.js















var BuildData = function() {
    var commit = "d305f4";
    var branch = "main";
    var date = parseInt(1646917993.041, 10);
    var buildDate = luxon.DateTime.fromSeconds(date).setZone('America/Chicago').toFormat('ccc. LLLL d, yyyy, h:mm a ZZZZ');
    return branch && commit && buildDate ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: footer_module.build,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* default */.Z, {
            size: "micro",
            "aria-hidden": "true",
            children: [
                "Version",
                ' ',
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("code", {
                    children: [
                        branch,
                        "/",
                        commit
                    ]
                }),
                ' ',
                "built with",
                ' ',
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    role: "img",
                    "aria-label": "love",
                    children: "❤️"
                }),
                ' ',
                "on ",
                buildDate,
                " by robots without emotions."
            ]
        })
    }) : null;
};
var Footer = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("footer", {
        role: "contentinfo",
        className: footer_module.footer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                href: "/",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                href: "/donate",
                                children: "Donate"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                href: "/guide",
                                children: "Guide"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                href: "/petitions",
                                children: "Petitions"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                href: "https://resist.bot/podcasts/live",
                                children: "Live"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                href: "https://cottonbureau.com/people/resistbot",
                                rel: "external",
                                children: "Shop"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                href: "/about",
                                children: "Help"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                href: "/".concat(siteconfig["default"].blog.baseURL),
                                children: "News"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* default */.Z, {
                    children: [
                        "Resistbot is a free service, but message and data rates may apply if you use the service over SMS. Message frequency varies. Text STOP to 50409 to stop all messages. Text HELP to 50409 for help. Here are our full",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "/terms",
                            children: "terms"
                        }),
                        " and",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "/privacy",
                            children: "privacy\xa0notice"
                        }),
                        " and",
                        ' ',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "/rights",
                            children: "user bill of\xa0rights"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* default */.Z, {
                    size: "small",
                    children: [
                        "Resistbot is a product ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                            children: "of"
                        }),
                        " the Resistbot Action Fund, a 501(c)(4) social welfare organization. Since we lobby on your behalf, donations are not tax-deductible as charitable\xa0contributions."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography_text/* default */.Z, {
                    size: "small",
                    children: [
                        "260 1st Ave. S.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Suite 200 Box 51",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Saint Petersburg, Fla. 33701"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: footer_module.social,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "https://twitter.com/intent/follow?screen_name=resistbot",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: twitter/* default */.Z,
                                alt: "Twitter"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "https://facebook.com/resistbot",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: facebook/* default */.Z,
                                alt: "Facebook"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "https://instagram.com/resistbot",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: instagram,
                                alt: "Instagram"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "https://t.me/resistbot",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: telegram,
                                alt: "Telegram"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "https://podcasts.apple.com/us/podcast/resistbot-live/id1587774264",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: pod,
                                alt: "Apple Podcasts"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "https://www.youtube.com/channel/UCEiQinjQvseC-U7Bs6sSpVQ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: youtube,
                                alt: "Youtube"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "https://twitch.tv/resistbot",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: twitch,
                                alt: "Twitch"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                            href: "https://www.reddit.com/r/resistbot/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: reddit,
                                alt: "Reddit"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildData, {})
            ]
        })
    });
};
/* harmony default export */ var footer = (Footer);

;// CONCATENATED MODULE: ./src/images/logo.svg
/* harmony default export */ var logo = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ./src/components/header.module.scss
var header_module = __webpack_require__(1428);
;// CONCATENATED MODULE: ./src/components/header.js






var Header = function(param) {
    var children = param.children, siteTitle = param.siteTitle;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: header_module.header,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                        className: header_module.columnView,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                label: "Resistbot Home",
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: header_module.logo,
                                    src: logo,
                                    alt: siteTitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: header_module.wrapView,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                            className: header_module.link,
                                            href: "/",
                                            children: "Home"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                            className: header_module.link,
                                            href: "/petitions",
                                            children: "Petitions"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                            className: header_module.link,
                                            href: "/donate",
                                            children: "Donate"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                            className: header_module.link,
                                            href: "/guide",
                                            children: "Guide"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                            className: header_module.link,
                                            href: "/about",
                                            children: "Help"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography_anchor/* default */.Z, {
                                            className: header_module.link,
                                            href: "/news",
                                            children: "News"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    children
                ]
            })
        })
    });
};
Header.propTypes = {
    siteTitle: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node
};
/* harmony default export */ var components_header = (Header);

;// CONCATENATED MODULE: ./src/images/shares/home.png
/* harmony default export */ var home = ("/_next/static/images/home-97fcbb1124be016f2bde684be69926b2.png");
// EXTERNAL MODULE: ./src/images/icons/iconPaths.js
var iconPaths = __webpack_require__(3129);
// EXTERNAL MODULE: ./src/utilities/proptype-validators.js
var proptype_validators = __webpack_require__(9685);
;// CONCATENATED MODULE: ./src/components/layout.js












function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var THEME_COLOR = '#0074e0';
var defaultShareImageAltText = 'Sign held at a protest stating "demand action from your elected officials, text resist to 50409." with overlay text that says "Text RESIST to 50409"';
// Maps our content to the OG standard types
var DATA_TYPES = {
    blog: 'article',
    petition: 'resistbot:petition',
    website: 'website'
};
var SITE_URL = siteconfig["default"].siteUrl;
var Layout = function(param) {
    var description = param.description, meta = param.meta, keywords = param.keywords, title = param.title, image = param.image, imageAltText = param.imageAltText, dataType = param.dataType, ogTitle = param.ogTitle, ogDescription = param.ogDescription, publishedOn = param.publishedOn, updatedOn = param.updatedOn, // Could be used by any/all pages if there's possibility of misformed URLs being shared around (petitions)
    canonicalPath = param.canonicalPath, // Some sort of special header/banner, like the homepage has
    header = param.header, // Elements it encloses
    children = param.children;
    var router = (0,next_router.useRouter)();
    var seo = {
        title: title || siteconfig["default"].title,
        description: description || siteconfig["default"].description,
        image: new URL(image || home, siteconfig["default"].siteUrl).href,
        imageAltText: imageAltText || defaultShareImageAltText,
        url: new URL(router.asPath, siteconfig["default"].siteUrl).href,
        author: siteconfig["default"].blog.authorTwitterUsername,
        ogTitle: ogTitle || title || siteconfig["default"].title,
        ogDescription: ogDescription || description || siteconfig["default"].description
    };
    var canonical = canonicalPath ? new URL(canonicalPath, siteconfig["default"].siteUrl).href : null;
    var _meta = [
        {
            name: "description",
            content: seo.description
        },
        {
            property: 'og:url',
            content: seo.url
        },
        {
            property: "og:title",
            content: seo.ogTitle
        },
        {
            property: "og:description",
            content: seo.ogDescription
        },
        {
            property: 'og:type',
            content: dataType
        },
        {
            property: "og:image",
            content: seo.image
        },
        {
            property: "og:image:alt",
            content: seo.imageAltText
        },
        // Twitter Specific (they use `name` rather than `property`)
        {
            name: "twitter:card",
            content: "summary_large_image"
        },
        {
            name: "twitter:title",
            content: seo.ogTitle
        },
        {
            name: "twitter:description",
            content: seo.ogDescription
        },
        {
            name: "twitter:image",
            content: seo.image
        },
        {
            name: "twitter:image:alt",
            content: seo.imageAltText
        },
        {
            name: "twitter:site",
            content: seo.author
        }, 
    ].concat(keywords && keywords.length > 0 ? {
        name: "keywords",
        content: keywords.join(", ")
    } : []).concat(dataType === DATA_TYPES.blog && publishedOn ? {
        property: 'article:published_time',
        content: publishedOn
    } : []).concat(dataType === DATA_TYPES.blog && updatedOn ? {
        property: 'article:modified_time',
        content: updatedOn
    } : [])// Theme Color sets the menu bar color on some androids and Safari
    .concat({
        name: 'theme-color',
        content: THEME_COLOR
    }).concat(meta);
    var metaElements = _meta.map(function(element) {
        if (!isEmpty_default()(element)) {
            var keyName = element.property ? 'property' : 'name';
            var content = element.content;
            var _obj;
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("meta", (_obj = {}, _defineProperty(_obj, keyName, element[keyName]), _defineProperty(_obj, "content", content), _defineProperty(_obj, "key", element[keyName]), _obj)));
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: seo.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    metaElements.map(function(metaElement) {
                        return metaElement;
                    }),
                    canonical ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: 'canonical',
                        href: canonical
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        type: "application/rss+xml",
                        href: "".concat(SITE_URL, "/feed.xml")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        type: "application/json",
                        href: "".concat(SITE_URL, "/feed.json")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        type: "application/atom+xml",
                        href: "".concat(SITE_URL, "/feed.atom")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        href: iconPaths/* icon48 */.hm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "32x32",
                        href: iconPaths/* icon48 */.hm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "48x48",
                        href: iconPaths/* icon48 */.hm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "72x72",
                        href: iconPaths/* icon72 */.BG
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "96x96",
                        href: iconPaths/* icon96 */.yd
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "144x144",
                        href: iconPaths/* icon144 */.ze
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "168x168",
                        href: iconPaths/* icon168 */.oF
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "192x192",
                        href: iconPaths/* icon192 */.nF
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "256x256",
                        href: iconPaths/* icon256 */.Gf
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "384x384",
                        href: iconPaths/* icon384 */.rq
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "512x512",
                        href: iconPaths/* icon512 */.Ye
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_header, {
                siteTitle: seo.title,
                children: header
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    }));
};
Layout.defaultProps = {
    lang: "en",
    meta: [],
    keywords: [],
    description: null,
    title: null,
    image: null,
    imageAltText: null,
    dataType: DATA_TYPES.website
};
Layout.propTypes = {
    lang: (prop_types_default()).string,
    meta: prop_types_default().arrayOf((prop_types_default()).object),
    description: (prop_types_default()).string,
    keywords: prop_types_default().arrayOf((prop_types_default()).string),
    title: (prop_types_default()).string.isRequired,
    image: (prop_types_default()).string,
    imageAltText: (prop_types_default()).string,
    dataType: prop_types_default().oneOf(Object.values(DATA_TYPES)),
    ogDescription: (prop_types_default()).string,
    ogTitle: (prop_types_default()).string,
    publishedOn: proptype_validators/* ISODateValidator */.L,
    updatedOn: proptype_validators/* ISODateValidator */.L,
    canonicalPath: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired,
    header: (prop_types_default()).node
};

/* harmony default export */ var layout = (Layout);


/***/ }),

/***/ 8472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9097);
/* harmony import */ var _anchor_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2926);
/* harmony import */ var _anchor_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_anchor_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Anchor = function(_param) {
    var children = _param.children, className = _param.className, href = _param.href, label = _param.label, rest = _objectWithoutProperties(_param, [
        "children",
        "className",
        "href",
        "label"
    ]);
    var isInternal = /^\/(?!\/)/.test(href);
    var aTagProps = isInternal ? {} : {
        rel: 'noreferrer'
    };
    if (label) {
        aTagProps['aria-label'] = label;
    }
    // https://github.com/vercel/next.js/issues/16107
    // Empty urls need a better default behavior
    // Server:
    // Error occurred prerendering page "/news/2021/02/09/the-vote". Read more: https://nextjs.org/docs/messages/prerender-error
    // TypeError: Cannot destructure property 'auth' of 'urlObj' as it is undefined.
    // Client:
    // Error: Failed prop type: The prop `href` expects a `string` or `object` in `<Link>`, but got `undefined` instead.
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], _objectSpread({
        href: href,
        passHref: true
    }, rest, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, _anchor_module_scss__WEBPACK_IMPORTED_MODULE_3__.anchor)
        }, aTagProps, {
            children: children
        }))
    })));
};
Anchor.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    href: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    label: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Anchor);


/***/ }),

/***/ 9852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _heading_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9621);
/* harmony import */ var _heading_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_heading_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var Heading = function(param) {
    var As = param.as, children = param.children, className = param.className, id = param.id, size = param.size;
    // "as" is what structural type it should be
    // "size" is if it should be styled differently than that
    // Deviations from this being consistent would be driven by visuals
    // that are sub-optimal when rendered as it's natural, structural type
    var styleSize = size ? size : As;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(As, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_heading_module_scss__WEBPACK_IMPORTED_MODULE_2__.heading, _heading_module_scss__WEBPACK_IMPORTED_MODULE_2__[styleSize], className),
        id: id,
        children: children
    }));
};
Heading.propTypes = {
    as: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ]).isRequired,
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf([
        'h0',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _text_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2958);
/* harmony import */ var _text_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_text_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Text = function(_param) {
    var tmp = _param.as, As = tmp === void 0 ? 'p' : tmp, className = _param.className, _size = _param.size, size = _size === void 0 ? 'normal' : _size, props = _objectWithoutProperties(_param, [
        "as",
        "className",
        "size"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(As, _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_text_module_scss__WEBPACK_IMPORTED_MODULE_2__[size], className)
    }, props)));
};
Text.propTypes = {
    as: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf([
        'micro',
        'small',
        'normal'
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 3129:
/***/ (function(module) {

"use strict";

// A mapping of where these images _should_ be stored, relative to the generated site root
module.exports.hm = '/favicons/icon-48x48.png';
module.exports.BG = '/favicons/icon-72x72.png';
module.exports.yd = '/favicons/icon-96x96.png';
module.exports.ze = '/favicons/icon-144x144.png';
module.exports.oF = '/favicons/icon-168x168.png';
module.exports.nF = '/favicons/icon-192x192.png';
module.exports.Gf = '/favicons/icon-256x256.png';
module.exports.rq = '/favicons/icon-384x384.png';
module.exports.Ye = '/favicons/icon-512x512.png';


/***/ }),

/***/ 7082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// Site Structure
var config = {
    // Note: Comes from next.config.js so doesn't map 1:1 with this actual env var
    siteUrl: "https://resist.bot",
    title: "Resistbot",
    description: "I'm Resistbot. Text RESIST to 50409 and I'll help you contact your representatives.",
    // Default, currently used in Blog feed top-level item.
    blog: {
        author: 'Resistbot',
        authorTwitterUsername: "@resistbot",
        baseURL: 'news'
    },
    lettersToTheEditor: {
        sheetID: '1fBeK7TtHTGetUDslTOcOV0H2vlh3spffxCV8qfLP2qU'
    }
};
/* harmony default export */ __webpack_exports__["default"] = (config);


/***/ }),

/***/ 9685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ ISODateValidator; }
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6299);

var ISODateValidator = function(props, propName, componentName) {
    var prop = props[propName];
    // Props that were not set are `undefined`, this validator will not throw on those.
    // Makes it "optional"
    if (typeof prop !== 'undefined') {
        var parsedDate = luxon__WEBPACK_IMPORTED_MODULE_0__.DateTime.fromISO(prop);
        if (parsedDate.invalid) {
            return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Validation failed: ").concat(parsedDate.invalid.explanation));
        }
    }
};


/***/ }),

/***/ 5185:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"container_container__qFY1k"};

/***/ }),

/***/ 8831:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__U4rpQ","social":"footer_social__fl_KD","build":"footer_build__cEdAY"};

/***/ }),

/***/ 1428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__moIix","wrapView":"header_wrapView__QN_8H","four":"header_four__l3gCE","logo":"header_logo__1WdMj","link":"header_link__1SYIB","columnView":"header_columnView__3xDeQ"};

/***/ }),

/***/ 2926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"anchor":"anchor_anchor__e6AjG"};

/***/ }),

/***/ 9621:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading_heading__cy6ep","h0":"heading_h0____LwV","h1":"heading_h1__NeBnZ","h2":"heading_h2__ZcWJw","h3":"heading_h3__cuaor"};

/***/ }),

/***/ 2958:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"micro":"text_micro__Ul93G","small":"text_small__c4eBH","centered":"text_centered__hrOuH"};

/***/ }),

/***/ 7095:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDY0ICg5MzUzNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+ZmFjZWJvb2s8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iZmFjZWJvb2siIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi44MTkxNzgsMjQgTDEuMzI0NjE2LDI0IEMwLjU5MjgzNiwyNCAwLDIzLjQwNjc5NTggMCwyMi42NzUzMDE0IEwwLDEuMzI0NjA1NDggQzAsMC41OTI5MjQ4NTIgMC41OTI5MjksMCAxLjMyNDYxNiwwIEwyMi42NzU0NzcsMCBDMjMuNDA2OTc3LDAgMjQsMC41OTI5MjQ4NTIgMjQsMS4zMjQ2MDU0OCBMMjQsMjIuNjc1MzAxNCBDMjQsMjMuNDA2ODg4OSAyMy40MDY4ODQsMjQgMjIuNjc1NDc3LDI0IEwxNi41NTk2NTMsMjQgTDE2LjU1OTY1MywxNC43MDU4NzczIEwxOS42NzkyNjEsMTQuNzA1ODc3MyBMMjAuMTQ2Mzc4LDExLjA4Mzc5MjggTDE2LjU1OTY1MywxMS4wODM3OTI4IEwxNi41NTk2NTMsOC43NzEzMjA3IEMxNi41NTk2NTMsNy43MjI2NDM2NSAxNi44NTA4NTYsNy4wMDgwMDQ4NCAxOC4zNTQ2NDUsNy4wMDgwMDQ4NCBMMjAuMjcyNjU2LDcuMDA3MTY2NzIgTDIwLjI3MjY1NiwzLjc2NzU0NTI3IEMxOS45NDA5NDMsMy43MjM0MDQxNyAxOC44MDIzOTIsMy42MjQ3ODUxMyAxNy40Nzc3NzYsMy42MjQ3ODUxMyBDMTQuNzEyNDE3LDMuNjI0Nzg1MTMgMTIuODE5MTc4LDUuMzEyNzYzMTMgMTIuODE5MTc4LDguNDEyNjA0NDMgTDEyLjgxOTE3OCwxMS4wODM3OTI4IEw5LjY5MTU2MSwxMS4wODM3OTI4IEw5LjY5MTU2MSwxNC43MDU4NzczIEwxMi44MTkxNzgsMTQuNzA1ODc3MyBMMTIuODE5MTc4LDI0IEwxMi44MTkxNzgsMjQgWiI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+");

/***/ }),

/***/ 1544:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ("data:image/svg+xml;base64,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");

/***/ })

}]);